export const LS_ENV_NAME = 'environment';

export const LS_FREIGHTER_ACCOUNT_CHANGE_IMMEDIATELY = 'freighter_account_change_immediately';

export const LS_DELEGATE_PROMO_VIEWED_LOCKER = 'delegate_promo_viewed_locker';

export const LS_LAST_AUTH_DATA = 'last_auth_data';

export const AMM_TOKENS_LIST = 'amm_tokens_list';

// Prefix for per-wallet notification service refresh tokens: the full key is
// `${LS_NOTIFICATIONS_REFRESH_TOKEN_PREFIX}${pubKey}`.
export const LS_NOTIFICATIONS_REFRESH_TOKEN_PREFIX = 'notifications_refresh_token_';
